module.exports = __webpack_public_path__ + "img/music-test-icon6.3cd81fb5.png";